import { data } from "jquery";
import API from "../../api/api";
const callApi = async (endpoint) => {
    try {
        const response = await API.get(endpoint);
        if (response.status === 200) {
            console.log("response", response);
            return response?.data?.data;
        } else {
            return response?.data?.data;
        }
    } catch (error) {
        console.log(error);
        throw error;
    }
};
export const IncentiveService = {
    callIncentives: async (date,userId) => {
    return callApi(`earned-incentives?date=${date}&userId=${userId}`);
  },
  callGemBonus : async (date,userId) => {
    return callApi(`gem-bonus?date=${date}&userId=${userId}`);
  },
  callEagleManager : async (date,userId) => {
    return callApi(`eagle-manager?date=${date}&userId=${userId}`);
  },
  callChairmanBonus : async (date,userId) => {
    return callApi(`chairman-bonus?date=${date}&userId=${userId}`);
  },

  callGlobalRally : async (date,userId) => {
    return callApi(`global-rally?date=${date}&userId=${userId}`);
  }
};